import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [accessToken, setAccessToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [refreshTokenExpiry, setRefreshTokenExpiry] = useState(null);

  // Load tokens from localStorage when app starts
  useEffect(() => {
    const savedAccessToken = localStorage.getItem("accessToken");
    const savedRefreshToken = localStorage.getItem("refreshToken");
    const savedRefreshTokenExpiry = localStorage.getItem("refreshTokenExpiry");

    if (savedAccessToken) setAccessToken(savedAccessToken);
    if (savedRefreshToken) setRefreshToken(savedRefreshToken);
    if (savedRefreshTokenExpiry) setRefreshTokenExpiry(savedRefreshTokenExpiry);
  }, []);

  // Login function: store tokens only
  const login = ({ accessToken, refreshToken, refreshTokenExpiry }) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("refreshTokenExpiry", refreshTokenExpiry);

    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
    setRefreshTokenExpiry(refreshTokenExpiry);
  };

  // Logout function: remove tokens
  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("refreshTokenExpiry");

    setAccessToken(null);
    setRefreshToken(null);
    setRefreshTokenExpiry(null);
  };

  const isAuthenticated = !!accessToken;

  return (
    <AuthContext.Provider
      value={{
        accessToken,
        refreshToken,
        refreshTokenExpiry,
        login,
        logout,
        isAuthenticated
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};